module.exports = __webpack_public_path__ + "img/menu-yw.adb9950b.png";